import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Col, Container, Row } from "../../grid";
import { useReactPath } from "../../utils/use-react-path";
import { Header } from "./Header";
import { Wrapper, StyledNav, TransparentLayer } from "./Navigation.styles";
import { MenuBar } from "./MenuBar";
export function Mobilenavigation({ logo, ariaLabel, menuBar, icons, router = undefined, homeLabel = "Home", backLabel = "Back", onChange, }) {
    const [isOpen, setIsOpen] = useState(false);
    const [containerHeight, setContainerHeight] = useState(0);
    const path = useReactPath();
    function toogleDrawer() {
        setIsOpen(!isOpen);
    }
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        }
        else {
            document.body.style.overflow = "auto";
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(isOpen);
    }, [isOpen]);
    useEffect(() => {
        if (isOpen)
            setIsOpen(false);
    }, [path]);
    useEffect(() => {
        const resizeHandler = () => {
            setContainerHeight(window.innerHeight);
        };
        resizeHandler();
        window.addEventListener("resize", resizeHandler);
        return () => {
            window.removeEventListener("resize", resizeHandler);
        };
    }, []);
    return (_jsx(Wrapper, { children: _jsx(Container, { children: _jsx(Row, { children: _jsx(Col, { children: _jsxs(StyledNav, Object.assign({ "aria-label": ariaLabel }, { children: [_jsx(Header, { isDrawerOpen: isOpen, toogleDrawer: toogleDrawer, icons: icons, logo: logo }), _jsx(TransparentLayer, { onClick: () => setIsOpen(false), isDrawerOpen: isOpen }), _jsx(MenuBar, Object.assign({ router: router, containerHeight: containerHeight, isDrawerOpen: isOpen }, menuBar, { onChange: (selected) => {
                                    if (typeof menuBar.onChange === "function")
                                        menuBar.onChange(selected);
                                    if (selected.leaf) {
                                        setIsOpen(false);
                                    }
                                }, homeLabel: homeLabel, backLabel: backLabel }))] })) }) }) }) }));
}
